module.exports = __webpack_public_path__ + "img/emojione_sparkles.e40e04e6.svg";